import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import InstructionList from './instruction/List';
import InstructionCreate from './instruction/Create';
import InstructionDetail from './instruction/Detail';
import { injectIntl } from "react-intl";
export { getQuoteFields, getQuoteReplyFields } from './quotes/Router';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    CompensationType: { visible: false, label: '', required: false },
    TaskOrder: { visible: false, label: '', required: false },
    ProjectOrder: { visible: false, label: '', required: false },
    ProposedInstructionGivenDate: { visible: false, label: '', required: false },
    Description: { visible: false, label: '', required: false },
    Assumption: { visible: false, label: '', required: false },
    EarlyWarning: { visible: false, label: '', required: false },
    InstructQuote: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const tempFields = { ...defaultFields };

    const workflowItem = workflowsQA[wfid];

    tempFields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };

    if (placeholdersQA.ProposedInstructionClauses?.values) {
        tempFields.CompensationType = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.TYPE"], required: true };
        tempFields.CompensationType.clauses = placeholdersQA.ProposedInstructionClauses.values.filter(item => item.isActive === true);
    }

    if (placeholdersQA.TaskOrderOptionEnabled) {
        const taskOrderOptionEnabled = placeholdersQA.TaskOrderOptionEnabled?.values
            .find(phItem => phItem.field === 'TaskOrderOptionEnabled').isActive;

        if (taskOrderOptionEnabled) {
            const toTemplate = languageFile["CONTRACT.WF.COMPENSATION.FIELD.TASK_ORDER"];

            const to = toTemplate
                .replace("{TASK_ORDER}", (workflowsQA['38'] || {}).notificationName);

            tempFields.TaskOrder = { visible: true, label: to, required: false };
        }
    }

    if (placeholdersQA.ProjectOrderOptionEnabled) {
        const projectOrderOptionEnabled = placeholdersQA.ProjectOrderOptionEnabled?.values
            .find(phItem => phItem.field === 'ProjectOrderOptionEnabled').isActive;

        if (projectOrderOptionEnabled) {
            const poTemplate = languageFile["CONTRACT.WF.COMPENSATION.FIELD.PROJECT_ORDER"];

            const po = poTemplate
                .replace("{PROJECT_ORDER}", (workflowsQA['72'] || {}).notificationName);

            tempFields.ProjectOrder = { visible: true, label: po, required: false };
        }
    }

    tempFields.ProposedInstructionGivenDate = { visible: true, label: languageFile["CONTRACT.WF.P_INSTRUCTION.FIELD.GIVEN_DATE"], required: true };
    tempFields.Description = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: true };

    if (resources.ProposedInstructionLabel) {
        tempFields.Assumption = { visible: true, label: resources.ProposedInstructionLabel, required: true };
    }

    if (placeholdersQA.EWRelationEnabled) {
        const ewRelationEnabled = placeholdersQA.EWRelationEnabled.values
            .find(phItem => phItem.field === 'EWRelationEnabled').isActive;

        if (ewRelationEnabled) {
            let ewLabel = languageFile["CONTRACT.WF.COMPENSATION.LABEL.ASSOCIATED_EW"];
            try {
                ewLabel = ewLabel
                    .replace("{EARLY_WARNING}", (workflowsQA['1'] || workflowsQA['2'] || workflowsQA['74']).notificationName);
            } catch (error) {
                console.log('Error loading EW notification name!');
            }

            tempFields.EarlyWarning = { visible: true, label: ewLabel, required: false };
        }
    }

    if (workflowItem.quoteOptional) {
        tempFields.InstructQuote = { visible: true, label: languageFile["CONTRACT.WF.COMPENSATION.FIELD.INSTRUCT_QUOTE"], required: false };
    }

    const fields = { ...tempFields };

    const cenFields = placeholdersQA.Fields;

    cenFields?.values?.forEach(fieldItem => {
        if (fields[fieldItem.field]) {
            fields[fieldItem.field].visible = fieldItem.isActive;
        }
    });

    return fields;
}

//FD-8788 Only certain types are allowed to have this field
//NEC4 books (ECC, ECS, FMC, PSC, SC, TSC) introduced a new clause 65
const awareDateFieldAllowedContractTypes = ["NEC4 ECC", "NEC4 ECS", "NEC4 FMC", "NEC4 PSC", "NEC4 SC", "NEC4 TSC"]

export const checkIfAwareDateFieldAllowed = (contractType) => {
    for (const allowedType of awareDateFieldAllowedContractTypes) {
        if (contractType?.includes(allowedType)) {
            return true;
        }
    }
    return false;
}

class InstructionRouter extends React.Component {
    constructor(props) {
        super(props);
        this.notificationType = 'PRO';
        this.documentType = 'Document612pm';
        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;


        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;

        const pmWf = props.workflowGroupItem.workflows.find(wf => wf.id === 5);
        if (pmWf) {
            this.compAbbreviation_PM = pmWf.abbreviation;
        }

        this.ewRelationEnabled = true;
        try {
            this.ewRelationEnabled = (props.placeholders.find(ph => ph.replacementKey === 'EWRelationEnabled')
                .values.find(phItem => phItem.field === 'EWRelationEnabled').isActive);
        } catch (error) {
            console.log('EWRelationEnabled placeholder not available!');
            this.ewRelationEnabled = true;
        }
        if (this.ewRelationEnabled) {
            try {
                this.ewNotificationName = (this.props.workflowsQA['1'] || this.props.workflowsQA['2'] || this.props.workflowsQA['74']).notificationName;
            } catch (error) {
                throw new Error('EWRelationEnabled but EW Workflows not found!');
            }
        }
        this.taskOrderOptionEnabled = false;
        try {
            this.taskOrderOptionEnabled = (props.placeholders.find(ph => ph.replacementKey === 'TaskOrderOptionEnabled')
                .values.find(phItem => phItem.field === 'TaskOrderOptionEnabled').isActive);
        } catch (error) {
            console.log('TaskOrderOptionEnabled placeholder not available!');
            this.taskOrderOptionEnabled = false;
        }

        if (this.taskOrderOptionEnabled) {
            this.taskOrderAbbreviation = 'Task-';
            if (this.props.workflowsQA['38']) {
                this.taskOrderAbbreviation = this.props.workflowsQA['38'].abbreviation;
                this.taskOrderNotificationName = this.props.workflowsQA['38'].notificationName;
            }
        }

        this.projectOrderOptionEnabled = false;
        try {
            this.projectOrderOptionEnabled = (props.placeholders.find(ph => ph.replacementKey === 'ProjectOrderOptionEnabled')
                .values.find(phItem => phItem.field === 'ProjectOrderOptionEnabled').isActive);
        } catch (error) {
            console.log('ProjectOrderOptionEnabled placeholder not available!');
            this.projectOrderOptionEnabled = false;
        }

        if (this.projectOrderOptionEnabled) {
            this.projectOrderAbbreviation = 'Project-';
            if (this.props.workflowsQA['72']) {
                this.projectOrderAbbreviation = this.props.workflowsQA['72'].abbreviation;
                this.projectOrderNotificationName = this.props.workflowsQA['72'].notificationName;
            }
        }

        this.ceNotificationName = 'Compensation';
        if (this.props.workflowsQA['5'] || this.props.workflowsQA['7'] || this.props.workflowsQA['76']) {
            this.ceNotificationName = (this.props.workflowsQA['5'] || this.props.workflowsQA['7'] || this.props.workflowsQA['76']).notificationName;
        }

        this.fields = { ...defaultFields };
        this.fields.Assumption = props.resources.ProposedInstructionLabel;
        this.fields.ProposedInstructionGivenDate = this.props.intl.formatMessage({ id: 'CONTRACT.WF.P_INSTRUCTION.FIELD.GIVEN_DATE' });
        try {
            const cenFields = props.placeholders.find(ph => ph.replacementKey === 'Fields');
            if (cenFields) {
                cenFields.values.forEach(fieldItem => {
                    this.fields[fieldItem.field] = fieldItem.isActive ? fieldItem.display : '';
                });
            }
        } catch (error) {
            console.log('Error loading CEN Fields Placeholder!');
        }
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;
        return (
            <Routes caseSensitive>
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<InstructionList
                        {...this.props}
                        ewRelationEnabled={this.ewRelationEnabled}
                        taskOrderOptionEnabled={this.taskOrderOptionEnabled}
                        taskOrderNotificationName={this.taskOrderNotificationName}
                        projectOrderOptionEnabled={this.projectOrderOptionEnabled}
                        projectOrderNotificationName={this.projectOrderNotificationName}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        notificationType={this.notificationType}
                    />}
                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <InstructionCreate
                                {...this.props}
                                ewRelationEnabled={this.ewRelationEnabled}
                                taskOrderOptionEnabled={this.taskOrderOptionEnabled}
                                taskOrderNotificationName={this.taskOrderNotificationName}
                                projectOrderOptionEnabled={this.projectOrderOptionEnabled}
                                projectOrderNotificationName={this.projectOrderNotificationName}
                                ewNotificationName={this.ewNotificationName}
                                taskOrderAbbreviation={this.taskOrderAbbreviation}
                                projectOrderAbbreviation={this.projectOrderAbbreviation}
                                title={this.notificationName}
                                notificationType={this.notificationType}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    element={<InstructionDetail
                        {...this.props}
                        fields={this.fields}
                        ewRelationEnabled={this.ewRelationEnabled}
                        taskOrderOptionEnabled={this.taskOrderOptionEnabled}
                        taskOrderNotificationName={this.taskOrderNotificationName}
                        projectOrderOptionEnabled={this.projectOrderOptionEnabled}
                        projectOrderNotificationName={this.projectOrderNotificationName}
                        ewNotificationName={this.ewNotificationName}
                        ceNotificationName={this.ceNotificationName}
                        compAbbreviation_PM={this.compAbbreviation_PM}
                        taskOrderAbbreviation={this.taskOrderAbbreviation}
                        projectOrderAbbreviation={this.projectOrderAbbreviation}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        documentType={this.documentType}
                        notificationType={this.notificationType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                    />}
                />
            </Routes>
        );
    }
};

export default injectIntl(InstructionRouter);